import axios from 'axios';

export default function (context, val) {
    axios.cancelAll();
    context.commit('reload');
    context.dispatch('create_page', val);
}